import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { constants } from '../constants';
import Img404 from '../../public/404.svg';
import { useFirstProduct } from '../hooks/useProductsList';
import { AuthorizationAPI } from '../apis';
function Page404() {
    const navigate = useNavigate();
    const { firstProduct } = useFirstProduct();
    useEffect(() => {
        AuthorizationAPI.logError({
            msg: `Page not found: ${globalThis.window.location.href}`
        }).catch((err) => console.error('[Page404] logError failed:', err));
    }, []);
    return (_jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', children: _jsxs(Box, { textAlign: 'center', children: [_jsx("img", { src: Img404, alt: '404', width: 250, height: 230, style: { marginBottom: 34 } }), _jsx(Typography, { variant: "h5", color: '#000000DE', mb: 4, children: constants.title_404 }), _jsx(Typography, { variant: "body2", color: '#333333', sx: { marginBottom: 3.75 }, children: constants.desc_404 }), _jsx(Button, { variant: 'outlined', color: 'primary', onClick: () => {
                        navigate(`/${firstProduct}`);
                    }, "data-testid": "home-button", children: _jsx(Typography, { variant: "button", children: constants.return_to_home.toUpperCase() }) })] }) }));
}
export default Page404;
